
import { configureStore, combineReducers } from '@reduxjs/toolkit';
import { persistStore, persistReducer, FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

import appReducer from './features/appSlice';
import videoReducer from './features/videoSlice';
import listingReducer from './features/listingSlice';
import dashboardVideosReducer from './features/dashboardVideosSlice';

export interface RootState {
  video: ReturnType<typeof videoReducer>;
  listing: ReturnType<typeof listingReducer>;
  app: ReturnType<typeof appReducer>;
  dashboardVideos: ReturnType<typeof dashboardVideosReducer>;
}

const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['app', 'video', 'listing', 'dashboardVideos'], // only persist these reducers
};

const reducers = combineReducers({
  video: videoReducer,
  listing: listingReducer,
  app: appReducer,
  dashboardVideos: dashboardVideosReducer,
});

const persistedReducer = persistReducer(persistConfig, reducers);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
  devTools: process.env.NODE_ENV !== 'production',
});

export const persistor = persistStore(store);

export type AppDispatch = typeof store.dispatch;

export default store;
